<template>
  <div ref="chartRef" class="dashboard-chart" />
</template>

<script setup>
import { ref, watch, onMounted, onUnmounted } from 'vue'
import * as echarts from 'echarts'
import { usePageI18n } from '@/composables/usePageI18n.js'
import { getChartLabels, HOME_CHART_DATA_KEYS } from '@/utils/homeDashboardI18n.js'

const props = defineProps({
  stats: { type: Array, default: () => [] },
})

const chartRef = ref()
let chartInstance = null

const renderChart = (items) => {
  if (!chartRef.value) return
  if (!chartInstance) {
    chartInstance = echarts.init(chartRef.value)
  }
  const values = HOME_CHART_DATA_KEYS.map((key) => {
    const item = items?.find?.((d) => d.key === key)
    return item?.num ?? 0
  })
  chartInstance.setOption({
    tooltip: { trigger: 'axis' },
    grid: { left: '2%', right: '2%', top: '8%', bottom: '4%', containLabel: true },
    xAxis: {
      type: 'category',
      data: getChartLabels(),
      axisLabel: { fontSize: 12, color: '#909399' },
      axisLine: { lineStyle: { color: '#e4e7ed' } },
    },
    yAxis: {
      type: 'value',
      minInterval: 1,
      splitLine: { lineStyle: { color: '#f0f2f5' } },
      axisLabel: { color: '#909399' },
    },
    series: [{
      type: 'bar',
      data: values,
      barWidth: '42%',
      itemStyle: {
        borderRadius: [4, 4, 0, 0],
        color: {
          type: 'linear',
          x: 0, y: 0, x2: 0, y2: 1,
          colorStops: [
            { offset: 0, color: '#409eff' },
            { offset: 1, color: '#79bbff' },
          ],
        },
      },
    }],
  })
}

const handleResize = () => chartInstance?.resize()

const applyLabels = () => {
  if (props.stats?.length) renderChart(props.stats)
}
const { t } = usePageI18n(applyLabels)

watch(() => props.stats, (val) => {
  if (val?.length) renderChart(val)
}, { deep: true })

onMounted(() => {
  if (props.stats?.length) renderChart(props.stats)
  window.addEventListener('resize', handleResize)
})

onUnmounted(() => {
  window.removeEventListener('resize', handleResize)
  chartInstance?.dispose()
})
</script>

<style scoped>
.dashboard-chart {
  width: 100%;
  height: 280px;
}
</style>
